import Button from '@react/react-spectrum/Button';
import Heading from '@react/react-spectrum/Heading';
import React from 'react';
import animation from '../assets/examples/food-carton.gif';
import '../css/SignIn.css';
import { Analytics, EventName } from '../services/Analytics';
import { AppHeader } from './AppHeader';
import { Footer } from './Footer';
import { inject } from 'mobx-react';
import { StoreComponent } from './StoreComponent';
import { boundMethod } from 'autobind-decorator';

@inject('store')
export class SignIn extends StoreComponent {
    componentDidMount() {
        Analytics.event(EventName.ShowSignIn);
    }

    render() {
        return (
            <div className="SignIn">
                <AppHeader minimal={true}/>
                <div className="SignIn__center">
                    <div className="SignIn__card">
                        <div>
                            <Heading variant="pageTitle">
                                Ready to fold?
                            </Heading>
                        </div>
                        <img className="SignIn__image" alt="" src={animation} />
                        <p>
                            Sign in to your Adobe account to get started.
                        </p>
                        <Button variant="cta" onClick={this.signIn}>
                            Sign in
                        </Button>
                    </div>
                    <Footer overlay/>
                </div>
            </div>
        );
    }

    @boundMethod
    private signIn() {
        Analytics.event(EventName.AccountSignIn);
        this.props.store.account.shouldSignIn = true;
    }
}
